export default "__VITE_ASSET__Jsrqo4iR__"